'use es6';

import { DragSource, DropTarget } from 'react-dnd';
import { pick } from 'underscore';
import { FINDER_BULK_MOVE, FINDER_FOLDER_MOVE_FOLDER } from 'DesignData/actions/ActionTypes';
import * as FolderAssetTypes from 'DesignData/enums/FolderAssetTypes';
import { FINDER_FILE, FINDER_FOLDER } from 'DesignData/enums/DragDropItemTypes';
import { canMoveFile, canMoveFolder } from 'DesignData/helpers/finderHelpers';
export const folderDragSource = DragSource(FINDER_FOLDER, {
  canDrag(props) {
    const {
      bulkPermissions,
      folderPermissions,
      isMultiSelected
    } = props;
    return isMultiSelected ? bulkPermissions[FINDER_BULK_MOVE] : folderPermissions[FINDER_FOLDER_MOVE_FOLDER];
  },

  beginDrag(props) {
    return pick(props, ['folder', 'folderId', 'isMultiSelected', 'isSelected', 'parentFolderId']);
  }

}, (connect, monitor) => ({
  canDrag: monitor.canDrag(),
  connectDragPreview: connect.dragPreview(),
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
}));

function handleDrop(props, monitor) {
  if (monitor.didDrop()) {
    return;
  }

  if (monitor.isOver() !== monitor.isOver({
    shallow: true
  })) {
    return;
  }

  const {
    folderId,
    moveContents,
    moveSelectedAssets
  } = props;
  const item = monitor.getItem();

  if (item.parentFolderId === folderId || item.folderId === folderId) {
    return;
  }

  if (item.isMultiSelected) {
    moveSelectedAssets(folderId);
  } else {
    const itemType = monitor.getItemType();
    const [assetId, assetType] = itemType === FINDER_FILE ? [item.fileId, item.fileType] : [item.folderId, FolderAssetTypes.FOLDER];
    moveContents([{
      id: assetId,
      type: assetType,
      parentFolderId: item.parentFolderId
    }], folderId);
  }
}
/**
 * Exports
 */


export const folderDropTarget = DropTarget([FINDER_FILE, FINDER_FOLDER], {
  canDrop(props, monitor) {
    // Can't drop anything if parent folder is being dragged
    if (props.isParentDragging) {
      return false;
    }

    const item = monitor.getItem();
    const itemType = monitor.getItemType();

    if (item.isSelected) {
      return props.canMoveSelectedAssets;
    }

    switch (itemType) {
      case FINDER_FILE:
        {
          return canMoveFile(props.folder, item, props);
        }

      case FINDER_FOLDER:
        {
          return canMoveFolder(props.folder, item, props);
        }

      default:
        return false;
    }
  },

  drop: handleDrop
}, (connect, monitor) => {
  return {
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({
      shallow: true
    })
  };
});
export const rootFolderDropTarget = DropTarget([FINDER_FILE, FINDER_FOLDER], {
  drop: handleDrop
}, (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({
      shallow: true
    })
  };
});